import { Link } from 'react-router-dom';

/**
 * Minimal footer shown on candidate-facing public pages (/screen/:token).
 * Provides ongoing access to the legal notices required at point-of-collection
 * (GDPR Art.13) — without exposing the full C2C site nav that does not apply
 * to invited candidates.
 */
export default function CandidateFooter() {
  return (
    <footer className="w-full max-w-3xl mx-auto mt-10 pt-6 pb-4 px-4 text-center text-xs text-gray-500">
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-3">
        <Link to="/screen/privacy" className="hover:text-gray-700 underline-offset-2 hover:underline">
          Candidate Privacy Notice
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy" className="hover:text-gray-700 underline-offset-2 hover:underline">
          Privacy Policy
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/ai" className="hover:text-gray-700 underline-offset-2 hover:underline">
          AI Notice
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy/sub-processors" className="hover:text-gray-700 underline-offset-2 hover:underline">
          Sub-processors
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/contacts" className="hover:text-gray-700 underline-offset-2 hover:underline">
          Contact
        </Link>
      </nav>
      <p className="text-[11px] text-gray-400">
        Operated by <strong>Yevhenii Lisechko</strong> (Slovakia) · Data questions:{' '}
        <a href="mailto:privacy@jobskills.work" className="hover:text-gray-600 underline-offset-2 hover:underline">
          privacy@jobskills.work
        </a>
      </p>
    </footer>
  );
}
